/* ============================================================
   Find the Lady — the email sign-up as a three-card monte.
   Markup: snippets/find-the-lady.liquid. Styles: the "find the lady"
   block at the end of base.css. The table (deal, swaps, pick, reveal) is
   assets/ftl-table.js, which is honest by construction; the pick here reads
   the queen flag off the element that was tapped. The randomness only
   chooses which pair swaps; it never chooses the outcome.

   Canada treats a pure game of chance for a prize as a lottery (Criminal
   Code s.206), which is why this is a following game and not a draw: fast
   but followable, slower still under prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('ftl');
  if (!root) return;

  var MS = window.MagicStore || {};
  /* The goal is the email, so only a claim retires the game (Rich,
     2026-09-29: "it should always show"). Closing no longer rests it: it
     opens once per visit (session) and the side tab brings it back any time.
     A player who picked but never claimed keeps their prize; the game does
     not re-deal for them, it goes straight to the claim, so a miss can
     never be re-rolled by closing and coming back. */
  var KEY_PLAYED = 'ftl:played';
  var KEY_RESULT = 'ftl:result';   /* 'found' | 'missed', written at the pick */
  var KEY_CLAIMED = 'ftl:claimed'; /* written once Klaviyo takes the email */
  var KEY_SEEN = 'ftl:seen';       /* sessionStorage: auto-opened this visit */

  var tab = document.getElementById('ftl-tab');

  var panel = root.querySelector('.ftl__panel');
  var intro = root.querySelector('[data-ftl-step="intro"]');
  var claim = root.querySelector('[data-ftl-claim]');
  var doneEl = root.querySelector('[data-ftl-done]');
  var game = root.querySelector('[data-ftl-step="game"]');
  var emailEl = root.querySelector('#ftl-email');
  var errEl = root.querySelector('#ftl-err');
  var table = root.querySelector('[data-ftl-table]');
  var head = root.querySelector('[data-ftl-head]');
  var statusEl = root.querySelector('[data-ftl-status]');
  var resultEl = root.querySelector('[data-ftl-result]');
  var winEl = root.querySelector('[data-ftl-win]');
  var live = root.querySelector('[data-ftl-live]');

  /* A link to an offer (?offer=<id>) jumps the pop-up queue: the shopper
     clicked through for that offer, so the table stands down on that page
     and the offer teaser gets the screen alone. */
  var fromOffer = /[?&]offer=/.test(location.search);

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var forced = /[?&]ftl=1(&|$)/.test(location.search);

  /* ---------- storage: every read and write may throw ---------- */
  function readTime(key) {
    try { return parseInt(localStorage.getItem(key) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function writeTime(key) {
    try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
  }

  function readStr(key) {
    try { return localStorage.getItem(key) || ''; } catch (e) { return ''; }
  }
  function writeStr(key, v) {
    try { localStorage.setItem(key, v); } catch (e) {}
  }
  function seenThisVisit() {
    try { return sessionStorage.getItem(KEY_SEEN) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(KEY_SEEN, '1'); } catch (e) {}
  }

  /* Retired for good: the email was claimed. A play from before 09-29 has
     'ftl:played' but no stored result, and may well have been claimed, so
     it counts as done rather than asking a subscriber twice. */
  function finished() {
    return !!readStr(KEY_CLAIMED) || (!!readTime(KEY_PLAYED) && !readStr(KEY_RESULT));
  }
  /* Picked earlier, never claimed: the prize they won, else ''. */
  function pendingPrize() {
    return readStr(KEY_CLAIMED) ? '' : readStr(KEY_RESULT);
  }

  function showTab(on) {
    if (tab) tab.hidden = !on;
  }

  function excludedPath() {
    var p = location.pathname.toLowerCase();
    return p === '/cart' || p.indexOf('/checkout') === 0 || p.indexOf('/checkouts') > -1 ||
      p.indexOf('/account') === 0 || p === '/pages/game' || p === '/pages/find-the-lady' ||
      p.indexOf('/challenge') === 0;
  }

  /* The offer teaser (assets/offers.js) waits its turn behind the table:
     'pending' while the game is armed or open, 'done' once it closes,
     'off' when it will not open on this page at all. */
  function setState(s) {
    document.documentElement.setAttribute('data-ftl', s);
    try { document.dispatchEvent(new CustomEvent('ftl:state', { detail: s })); } catch (e) {}
  }

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px), (pointer: coarse)').matches);
  }

  function say(msg) { if (live) live.textContent = msg; }

  /* A fair integer in [0, n): crypto where there is one, rejection sampled. */
  function randInt(n) {
    if (window.crypto && window.crypto.getRandomValues) {
      var buf = new Uint32Array(1), limit = Math.floor(4294967296 / n) * n;
      do { window.crypto.getRandomValues(buf); } while (buf[0] >= limit);
      return buf[0] % n;
    }
    return Math.floor(Math.random() * n);
  }


  /* ---------- Klaviyo: best effort, never blocks the table ---------- */
  function post(path, payload) {
    if (typeof MS.klaviyoPost === 'function') return MS.klaviyoPost(path, payload);
    /* theme.js not loaded yet or failed: the same call, built the same way. */
    var key = (MS.notify && MS.notify.klaviyoKey) || '';
    if (!key) return Promise.reject(new Error('No Klaviyo key configured'));
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return true; });
  }

  /* Called at the claim, after the pick: the email is how the prize is
     collected, so the subscription and the play event travel together. */
  function subscribe(email) {
    /* Returns the promise: the claim screen says "check your inbox" only
       once Klaviyo has taken the address (QA 2026-09-29 #30). */
    var listId = root.getAttribute('data-list') || 'XZ74by';
    /* The client endpoint takes consent from the call itself; a
       'subscriptions' block on the profile is refused with a 400 at this
       revision (it belongs to the private-key API). */
    var profile = { data: { type: 'profile', attributes: { email: email } } };
    var sub = post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'Find the Lady', profile: profile },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
    sub.catch(function (e) { if (window.console) console.warn('[find the lady]', e && e.message); });
    return sub;
  }

  function report(email, found, swaps) {
    var evt = post('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            found: found,
            prize_percent: found ? 15 : 10,
            swaps: swaps,
            device: isMobile() ? 'mobile' : 'desktop',
            page: location.pathname
          },
          metric: { data: { type: 'metric', attributes: { name: 'Played Find the Lady' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });
    evt.catch(function (e) { if (window.console) console.warn('[find the lady]', e && e.message); });
  }

  /* ---------- open / close ---------- */
  var isOpen = false, opener = null, played = false, busy = false, lastFound = false;
  /* Once the table has been closed it stays closed for this page view. Every
     deferred path into open() (the delay timer, the scroll and exit
     triggers, the wait-for-the-banner retry) checks this, and the retry and
     the hide timer are single handles cleared on close/open, so nothing
     queued earlier can bring it back or lock the page (QA 2026-09-29 #1). */
  var closedForGood = false, retryTimer = null, hideTimer = null;

  function otherModalOpen() {
    if (document.querySelector('dialog[open]')) return true;
    /* Shopify's cookie banner sits above everything (z 2000000) and would
       cover the table; the game waits until the visitor has answered it. */
    var consent = document.getElementById('shopify-pc__banner');
    if (consent && consent.offsetHeight > 0) return true;
    /* Rich, 10-08: the CAD/USD question (snippets/cad-prompt) comes right after the cookie banner. */
    if (/^(pending|open)$/.test(document.documentElement.getAttribute('data-cadp') || '')) return true;
    /* One pop-up at a time: never over the offer teaser. */
    var dock = document.querySelector('[data-offer-dock]');
    if (dock && !dock.hidden) return true;
    return document.documentElement.style.overflow === 'hidden';
  }

  /* ---------- the page holds still while they play ----------
     Trailers keep playing behind a pop-up and pull the eye off the queen.
     Pause every video on open; while open, anything the page tries to
     (re)start is paused again (the hero carousel and scroll-in players
     call play() on their own). On close, resume only what was playing. */
  var held = [];
  function holdVideo(e) {
    var v = e.target;
    if (!isOpen || !v || v.tagName !== 'VIDEO' || root.contains(v)) return;
    /* It wanted to play, so it gets its turn once the table is closed. */
    if (held.indexOf(v) < 0) held.push(v);
    v.pause();
  }
  function stillPage() {
    held = [];
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (root.contains(v)) return;
      if (!v.paused) { held.push(v); v.pause(); }
    });
    document.addEventListener('play', holdVideo, true);
  }
  function wakePage() {
    document.removeEventListener('play', holdVideo, true);
    held.forEach(function (v) {
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
    held = [];
  }

  /* manual: the shopper tapped the side tab. That is their choice, so it
     skips the queue checks and works even after an earlier close. */
  function open(manual) {
    if (isOpen || (closedForGood && manual !== true)) return;
    if (manual !== true && !forced && otherModalOpen()) {
      /* One pending retry at most, however many triggers fire meanwhile. */
      if (!retryTimer) retryTimer = setTimeout(function () { retryTimer = null; open(); }, 2000);
      return;
    }
    isOpen = true;
    markSeen();
    showTab(false);
    detachTriggers();
    clearTimeout(hideTimer); hideTimer = null;
    if (!played && pendingPrize()) resumeClaim(pendingPrize() === 'found');
    stillPage();
    opener = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    /* The keyboard should not jump up uninvited on a phone. */
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var deal = intro.querySelector('[data-ftl-deal]');
      if (isMobile() || !deal) panel.focus({ preventScroll: true });
      else deal.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    closedForGood = true;
    detachTriggers();
    wakePage();
    showTab(!finished());
    setState('done');
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { hideTimer = null; if (!isOpen) root.hidden = true; }, reduced ? 0 : 260);
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ftl-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      /* Keep focus inside the dialog. */
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null && el.tabIndex >= 0; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  /* ---------- step 1: the invitation ---------- */
  intro.querySelector('[data-ftl-deal]').addEventListener('click', function () {
    intro.hidden = true;
    game.hidden = false;
    play();
  });

  /* ---------- step 2: the game ----------
     The table itself is assets/ftl-table.js, shared with the signed-in daily
     game. Here the browser plans the swaps: the prize is a code a Klaviyo
     flow sends, so there is nothing for a server to guard. */
  var tbl = window.FtlTable(table, {
    reduced: reduced,
    onTurned: function () {
      statusEl.textContent = 'Follow her…';
      say('The cards are face down and moving.');
    }
  });

  /* The pair for each swap: any two seats, never the same pair twice running
     (that would just undo the last move). Chance picks the pair only. */
  var PAIRS = [[0, 1], [1, 2], [0, 2]];
  function planSwaps() {
    var n = 6 + randInt(3), out = [], last = -1;
    for (var i = 0; i < n; i++) {
      var k;
      do { k = randInt(3); } while (k === last);
      out.push(PAIRS[k]); last = k;
    }
    return out;
  }

  /* Fast but followable: each swap a little quicker than the one before. */
  function speeds(n) {
    var first = reduced ? 1100 : 640, lastDur = reduced ? 1000 : 330, out = [];
    for (var i = 0; i < n; i++) {
      var t = n > 1 ? i / (n - 1) : 1;
      out.push(Math.round(first + (lastDur - first) * (1 - Math.pow(1 - t, 2))));
    }
    return out;
  }

  function play() {
    busy = true;
    tbl.deal();
    head.textContent = 'Watch the queen.';
    statusEl.textContent = 'That’s her: the queen of hearts, in the middle.';
    say('Three cards: jack of spades, queen of hearts in the middle, king of clubs. Watch the queen.');
    var plan = planSwaps();
    tbl.shuffle(plan, speeds(plan.length)).then(function () {
      busy = false;
      head.textContent = 'Where’s the Queen?';
      statusEl.textContent = isMobile() ? 'Tap a card.' : 'Click a card, or use the arrow keys and Enter.';
      say('Where’s the Queen? Pick the left, middle or right card.');
      tbl.ready(function (el) { if (!played) pick(el); });
    });
  }

  /* ---------- step 3: the result ---------- */
  function pick(el) {
    played = true;
    busy = true;
    writeTime(KEY_PLAYED);

    /* The answer is read off the element that was tapped. */
    var found = tbl.isQueen(el);
    lastFound = found;
    writeStr(KEY_RESULT, found ? 'found' : 'missed');

    tbl.reveal(el, found).then(function () {
      head.textContent = found ? 'Nice eye.' : 'So close.';
      statusEl.textContent = '';
      statusEl.hidden = true;
      winEl.innerHTML = found
        ? '<span class="ftl__prize">You won 15% off your first order.</span> <span class="ftl__ask">Where should we send your code?</span>'
        : '<span class="ftl__prize">You still won 10% off your first order.</span> <span class="ftl__ask">Where should we send your code?</span>';
      claim.hidden = false;
      say(winEl.textContent);
      /* The phone keyboard would cover the cards they just turned over. */
      if (!isMobile()) emailEl.focus({ preventScroll: true });
    });
  }

  /* ---------- step 4: the claim ---------- */
  claim.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = (emailEl.value || '').trim();
    if (!/^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/.test(v)) {
      errEl.textContent = 'That email doesn’t look right. Try again?';
      errEl.hidden = false;
      emailEl.setAttribute('aria-invalid', 'true');
      emailEl.focus();
      return;
    }
    var submit = claim.querySelector('[data-ftl-claim-btn]');
    var submitText = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Sending…'; }
    errEl.hidden = true;
    emailEl.removeAttribute('aria-invalid');
    subscribe(v).then(function () {
      report(v, lastFound, tbl.swaps());
      claimed(v);
    }, function () {
      if (submit) { submit.disabled = false; submit.textContent = submitText; }
      errEl.textContent = 'We couldn’t sign you up just then. Check your connection and try again.';
      errEl.hidden = false;
      say(errEl.textContent);
    });
  });

  /* Back for a prize they already won: no new deal, straight to the claim. */
  function resumeClaim(found) {
    lastFound = found;
    intro.hidden = true;
    game.hidden = false;
    table.hidden = true;
    statusEl.hidden = true;
    head.textContent = 'Your prize is waiting.';
    winEl.innerHTML = found
      ? '<span class="ftl__prize">You won 15% off your first order.</span> <span class="ftl__ask">Where should we send your code?</span>'
      : '<span class="ftl__prize">You won 10% off your first order.</span> <span class="ftl__ask">Where should we send your code?</span>';
    claim.hidden = false;
    say(winEl.textContent);
  }

  function claimed(v) {
    writeStr(KEY_CLAIMED, String(Date.now()));
    showTab(false);
    claim.hidden = true;
    head.textContent = 'Check your inbox.';
    doneEl.textContent = (lastFound ? '15%' : '10%') + ' off is on its way to ' + v + '.';
    resultEl.hidden = false;
    var note = resultEl.querySelector('.ftl__note');
    say(doneEl.textContent + (note ? ' ' + note.textContent : ''));
    var btn = resultEl.querySelector('button');
    if (btn) btn.focus({ preventScroll: true });
  }

  /* ---------- triggers ---------- */
  var timer = null;
  /* Browse first (Rich, 2026-09-29: "it needs to give time for people to
     browse through the site first"). Never on the landing page; from the
     second page of the visit, once the visit is 45s old and this page has
     had 20s (or the theme's delay setting, if longer). A desktop exit
     intent may open it earlier, but not in the first 30s of the visit.
     The side tab is there from the first page for anyone who wants it. */
  var MIN_PAGES = 2, MIN_VISIT = 45e3, MIN_PAGE = 20e3, MIN_EXIT = 30e3;
  function visitStats() {
    var pages = 1, t0 = Date.now();
    try {
      pages = (parseInt(sessionStorage.getItem('ftl:pages') || '0', 10) || 0) + 1;
      sessionStorage.setItem('ftl:pages', String(pages));
      t0 = parseInt(sessionStorage.getItem('ftl:t0') || '0', 10) || 0;
      if (!t0) { t0 = Date.now(); sessionStorage.setItem('ftl:t0', String(t0)); }
    } catch (e) {}
    return { pages: pages, t0: t0 };
  }
  function onExit(e) {
    if (!e.relatedTarget && e.clientY <= 0 && Date.now() - visit.t0 >= MIN_EXIT) open();
  }
  function detachTriggers() {
    clearTimeout(timer); timer = null;
    clearTimeout(retryTimer); retryTimer = null;
    document.removeEventListener('mouseout', onExit);
  }

  /* The account menu's "Find the Queen" link (data-ftl-open) opens this
     pop-up in place. Once the code is claimed the link goes away with the
     tab. Where the pop-up is not on the page, the link's own href (/?ftl=1)
     takes them to one that has it. */
  var menuLinks = document.querySelectorAll('[data-ftl-open]');
  for (var i = 0; i < menuLinks.length; i++) menuLinks[i].hidden = finished();
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-ftl-open]');
    if (!link || finished()) return;
    e.preventDefault();
    if (window.msCloseAccount) window.msCloseAccount();
    open(true);
  });

  /* Ask Pip's "Play" button opens the game in place. */
  window.msOpenFtl = function () { open(true); };

  if (forced) {
    setState('pending');
    setTimeout(open, 400);
    return;
  }
  if (root.getAttribute('data-editor') === '1' || excludedPath() || finished()) { setState('off'); return; }

  /* With Ask Pip on, the game never opens by itself: Pip offers it in the chat. */
  if (root.hasAttribute('data-manual')) { setState('done'); return; }

  /* The side tab: always there until the email is claimed. */
  if (tab) {
    tab.addEventListener('click', function () { open(true); });
    showTab(true);
  }

  /* Opens by itself once per visit; after that the tab is the way back.
     An offer link gives that page to the offer teaser alone. */
  if (fromOffer || seenThisVisit()) { setState('done'); return; }
  setState('pending');

  var visit = visitStats();
  var delay = parseInt(root.getAttribute('data-delay'), 10) * 1000;
  var pageWait = Math.max(MIN_PAGE, delay > 0 ? delay : 0);
  if (visit.pages >= MIN_PAGES) {
    var wait = Math.max(pageWait, MIN_VISIT - (Date.now() - visit.t0));
    timer = setTimeout(open, wait);
  }
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)').matches) {
    document.addEventListener('mouseout', onExit);
  }
})();
